import { Button } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  page: {
    background: "#f5f7fa",
    padding: "40px 20px",
    minHeight: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  descrippt: {
    fontSize: 21,
    fontWeight: 500,
    marginTop: "15px",
    marginBottom: "10px",
    textAlign: "center",
  },
  descripptTxt: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
    textAlign: "center",
  },
  lkLink: {
    marginTop: 12,
    color: "#1976d2",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: 14,
  },
  button: {
    backgroundColor: "#5664F5",
    height: "40px",
    fontSize: 14,
    fontWeight: 600,
    borderRadius: "10px",
    marginTop: "20px",
    padding: "0 14px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#4352d6",
    },
    fontFamily: "Montserrat",
  },
  card: {
    background: "#fff",
    borderRadius: 20,
    padding: "62px 20px",
    maxWidth: 450,
    width: "100%",
    boxShadow: "0 12px 36px rgba(0, 0, 0, 0.06)",
  },
  supportPhone: {
    marginTop: 6,
    marginBottom: 0,
    fontSize: 16,
    fontWeight: 500,
  },
}));

export default function FaultPage() {
  const classes = useStyles();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const orgParam = params.get("org");

  const handleRetry = () => {
    window.history.back();
  };

  const getSupportInfo = () => {
    switch (orgParam) {
      case 'АО "РИЦ"':
        return {
          orgName: 'АО "РИЦ"',
          phone: process.env.REACT_APP_SUPPORT_PHONE_RIC || "",
          link: "https://flk.ricso.ru",
        };
      case 'ООО "ЮРИЦ"':
        return {
          orgName: 'ООО "ЮРИЦ"',
          phone: process.env.REACT_APP_SUPPORT_PHONE_URIC || "",
          link: "https://flk.vostok-electra.ru/login",
        };
      case 'АО "ЕРИЦ ЯНАО"':
        return {
          orgName: 'АО "ЕРИЦ ЯНАО"',
          phone: process.env.REACT_APP_SUPPORT_PHONE_ERIC || "",
          link: "https://flk.vostok-electra.ru/login",
        };
      default:
        return {
          orgName: "АО «ЭК «Восток»",
          phone: process.env.REACT_APP_SUPPORT_PHONE || "",
          link: "https://flk.vostok-electra.ru/login",
        };
    }
  };

  const support = getSupportInfo();

  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "60px" }}
            src="../../../../error.png"
            alt="error"
          />

          <div className={classes.descrippt}>Ошибка при формировании QR</div>

          <div className={classes.descripptTxt}>
            Произошла ошибка системы при попытке сформировать QR. Пожалуйста,
            обратитесь в колл-центр или воспользуйтесь Личным кабинетом
          </div>

          <div style={{ marginTop: "5px" }} className={classes.supportPhone}>
            {support.orgName}
          </div>
          <div style={{ marginTop: "0px" }} className={classes.supportPhone}>{support.phone}</div>

          <a
           href={support.link}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.lkLink}
          >
            Личный кабинет
          </a>

          <Button
            variant="contained"
            className={classes.button}
            onClick={handleRetry}
          >
            Попробовать еще раз
          </Button>
        </div>
      </div>
    </div>
  );
}
